import {
  Input,
  Output,
  Component,
  OnDestroy,
  EventEmitter,
  ChangeDetectionStrategy,
} from '@angular/core';
import { AbstractControl, UntypedFormBuilder } from '@angular/forms';

import { SnMessage } from '../../../models';

@Component({
  selector: 'sn-message-edit',
  templateUrl: './message-edit.component.html',
  styleUrls: ['./message-edit.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SnMessageEditComponent implements OnDestroy {
  @Input() set message(value: SnMessage) {
    this.textControl.patchValue(value.twilio.body);
  }

  @Output()
  public readonly cancel = new EventEmitter<void>();

  @Output()
  public readonly save = new EventEmitter<string>();

  public readonly textControl: AbstractControl;

  constructor(formBuilder: UntypedFormBuilder) {
    this.textControl = formBuilder.control(null);
  }

  public ngOnDestroy(): void {
    this.cancel.complete();
    this.save.complete();
  }

  public cancelChanges(): void {
    this.cancel.emit();
  }

  public saveChanges(): void {
    this.save.emit(this.textControl.value);
  }
}
